import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { EvaluationSubmissionResult } from '@treams/treams-network';
import { Paragraph, tokens } from '@treams/treams-ui';

const Copy = styled(Paragraph)`
	margin: 0;
	min-width: 0;

	strong {
		font-weight: ${tokens.typography.weights.medium};
	}
`;

export default function IrrelevantAnswerDisplay({
	result,
}: {
	result: EvaluationSubmissionResult;
}) {
	const { t } = useTranslation();

	return (
		<Copy>
			<strong>{result.user.firstName} </strong>
			{t('conversations.answers.irrelevantAnswer')}
		</Copy>
	);
}
